$(function () {
  // Owl Carousel
  var owl = $("#extinguishing-owl");
  owl.owlCarousel({
    items: 3,
    margin: 20,
    loop: true,
    nav: false,
    responsive: {
      0: {
        items: 1
      },

      768: {
        items: 1
      },

      1024: {
        items: 2
      },

      1366: {
        items: 3
      }
    }
  });
});



$(document).ready(function () {
  $('#owl-carousel-extinguishing').owlCarousel({
    loop: true,
    items: 1,
    slideSpeed: 2000,
    autoplay: true,
    thumbs: true,
    thumbImage: true,
    thumbContainerClass: 'owl-thumbs',
    thumbItemClass: 'owl-thumb-item'
  });
});
// window.addEventListener('scroll', function() {
//   let header = document.querySelector('header');
//   header.classList.toggle('sticky', window.scrollY > 700);
// });


$(document).ready(function(){
  $('#lightgallery').lightGallery();
});

function redirectToLink(link,count) {
  
  if(count > 2){  
    window.open(link, '_self');
}
  else{ window.open(link, '_blank');
}
}
